import type { CommerceResponseBody } from './CommerceResponseBody';

export class BFFHttpError extends Error {
    public readonly status: number;

    public readonly body?: CommerceResponseBody;

    constructor(status: number, message: string, body?: CommerceResponseBody, stack?: string) {
        super(message);
        this.status = status;
        this.body = body;
        if (stack) {
            this.stack = stack;
        }
    }
}
